import { render, staticRenderFns } from "./cuadernos.vue?vue&type=template&id=1072796e"
import script from "./cuadernos.vue?vue&type=script&lang=js"
export * from "./cuadernos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports